import { Controller } from "@hotwired/stimulus"

// Auto-uzupełnia pola projekt i klient w formularzu workinfo po wyborze zadania.
// Po zmianie zadania pobiera z serwera projekt/klienta zadania i od razu wstawia je
// w odpowiednie intum_select (jak w S1). Wypełnia tylko to, co zadanie posiada.
export default class extends Controller {
  static targets = ["taskSelect", "projectSelect", "clientSelect"]
  static values = { tasksUrl: String }

  connect() {
    if (this.hasTaskSelectTarget) {
      this.onTaskChange = this.taskChanged.bind(this)
      this.taskSelectTarget.addEventListener("change", this.onTaskChange)
    }
  }

  disconnect() {
    if (this.hasTaskSelectTarget && this.onTaskChange) {
      this.taskSelectTarget.removeEventListener("change", this.onTaskChange)
    }
  }

  taskChanged() {
    const taskId = this.selectedValue(this.taskSelectTarget)
    if (!taskId || taskId === "none") { return }

    const url = this.tasksUrlValue.replace("__ID__", encodeURIComponent(taskId))
    fetch(url, { headers: { Accept: "application/json" } })
      .then(response => response.ok ? response.json() : null)
      .then(data => {
        if (!data) { return }
        // projekt najpierw - jego zmiana (przez after-change-update) czyści klienta,
        // dlatego klienta ustawiamy zaraz po tym
        if (data.project && this.hasProjectSelectTarget) {
          this.setValue(this.projectSelectTarget, data.project, true)
        }
        if (data.client && this.hasClientSelectTarget) {
          this.setValue(this.clientSelectTarget, data.client, false)
        }
      })
      .catch(() => {})
  }

  // odczyt aktualnie wybranej wartości single-select intum_select z hidden inputów
  selectedValue(wrapper) {
    return Array.from(wrapper.querySelectorAll(".hidden-fields-container input[type='hidden']"))
      .map(input => input.value)
      .join("")
  }

  // ustawia wartość single-select intum_select: czyści poprzednią, dodaje hidden input i bąbelek
  setValue(wrapper, item, dispatchChange) {
    const fieldName = wrapper.dataset.intumSelectFieldNameValue
    const container = wrapper.querySelector(".hidden-fields-container")
    const bubblesContainer = wrapper.querySelector("[data-intum-select-target='bubblesContainer']")
    const template = wrapper.querySelector("template[data-intum-select-target='bubbleTemplate']")
    if (!container || !bubblesContainer || !template) { return }

    // usuwamy stary bąbelek/single_value i hidden inputy
    wrapper.querySelectorAll("[data-bubble]").forEach(bubble => bubble.remove())
    container.querySelectorAll("input[type='hidden']").forEach(input => input.remove())

    // hidden input z nową wartością
    const hidden = document.createElement("input")
    hidden.type = "hidden"
    hidden.name = fieldName
    hidden.value = item.id
    container.appendChild(hidden)

    // bąbelek z nazwą wybranej wartości
    const bubble = template.content.cloneNode(true)
    bubble.querySelector("#bubble").dataset.bubble = item.id
    bubble.querySelector("#name").textContent = item.name
    bubblesContainer.prepend(bubble)

    if (dispatchChange) {
      wrapper.dispatchEvent(new Event("change", { bubbles: true }))
    }
  }
}
